<mat-icon class="mat-icon-[80px]" color="warn">{{
  error?.failureIcon
}}</mat-icon>
<div class="text-warn text-center mt-[10px] w-full uppercase">
  {{ error?.failureMessage }}
</div>
